module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'store') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.title),
      callback: function($$v) {
        _vm.$set(_vm.base, "title", $$v)
      },
      expression: "base.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.base, "subtitle", $$v)
      },
      expression: "base.subtitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推荐店铺"
    }
  }, [_c('draggable', {
    staticClass: "content-bottom-padded",
    attrs: {
      "options": _vm.dragItemsOptions
    },
    on: {
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  }, _vm._l((_vm.data), function(store, index) {
    return _c('div', {
      key: index,
      staticClass: "setting-item item-selected"
    }, [_c('div', {
      staticClass: "store-card"
    }, [(store.id) ? [_c('div', {
      staticClass: "view-flex view-flex-middle"
    }, [_c('img', {
      staticClass: "store-logo",
      attrs: {
        "src": store.logo || 'https://fakeimg.pl/120x120/EFEFEF/CCC/?text=logo&font=lobster',
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "store-name"
    }, [_vm._v(_vm._s(store.name))])]), _vm._v(" "), _c('div', {
      staticClass: "store-items"
    }, _vm._l((store.items), function(item, idx) {
      return (idx < 4) ? _c('div', {
        staticClass: "store-item"
      }, [_c('img', {
        staticClass: "store-item-thumb",
        attrs: {
          "src": item.imgUrl,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "store-item-amount"
      }, [_c('span', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(item.price / 100))])])]) : _vm._e()
    }), 0)] : [_c('div', {
      staticClass: "store-placeholder"
    }, [_c('div', {
      staticClass: "view-flex view-flex-middle"
    }, [_c('div', {
      staticClass: "logo"
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "name"
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "view-flex"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "thumb"
    }), _vm._v(" "), _c('div', {
      staticClass: "price"
    })]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "thumb"
    }), _vm._v(" "), _c('div', {
      staticClass: "price"
    })]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "thumb"
    }), _vm._v(" "), _c('div', {
      staticClass: "price"
    })]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "thumb"
    }), _vm._v(" "), _c('div', {
      staticClass: "price"
    })])])])], _vm._v(" "), _c('div', {
      staticClass: "setting-modal"
    }, [_c('div', {
      staticClass: "iconfont icon-arrows-alt"
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-cog",
      on: {
        "click": function($event) {
          return _vm.handleGoods(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-trash-alt1",
      on: {
        "click": function($event) {
          return _vm.handleRemove(index)
        }
      }
    })])], 2)])
  }), 0), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "iconfont icon-plus-circle banner-button-uploader",
    attrs: {
      "disabled": _vm.data.length >= 5,
      "type": "default"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v(" 添加推荐")])], 1)], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-708990b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-708990b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/store.vue
// module id = 2814
// module chunks = 0